import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';

import { RoleType } from '../services/role.service';
import { UserService } from '../services/user.service';
import { ToastService } from '../../shared/services/toast.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}
  toastSvc = inject(ToastService);
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const expectedRoles = route.data['roles'] as RoleType[];
    const defaultRedirect = this.userService.routeToRedirectWithPermission();

    return this.userService.userLoaded$.pipe(
      filter(Boolean),
      take(1),
      switchMap(() => {
        // console.log("Checking user roles...", route.url);
        if (expectedRoles.length) {
          return this.userService.hasRoles$(expectedRoles).pipe(
            take(1),
            map((hasRole) => {
              if (!hasRole) {
                // this.toastSvc.error(
                //   "You do not have permission to access this page."
                // );
                this.router.navigate([defaultRedirect]);
              }
              return hasRole;
            })
          );
        } else {
          return of(true);
        }
      })
    );
  }
}
